import { Directive, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appZipCodeValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ZipCodeValidatorDirective,
      multi: true
    }
  ],
  standalone: false
})
export class ZipCodeValidatorDirective implements Validator {
  private zipCodeRegex = /^\d{5}(-\d{4})?$/;

  constructor(private el: ElementRef) { }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value && !this.zipCodeRegex.test(value)) {
      return { zipCodeInvalid: true };
    }
    return null;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Home', 'End'
    ];

    const isNumber = /^[0-9]$/.test(event.key);
    const isDash = event.key === '-';

    if (!isNumber && !isDash && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
